import { Color } from '@/constants/color';
import Button from '@/ui/components/Button';

// Client-side filtering of whatever slice a panel has already loaded — no
// refetch, so typing stays responsive against a deep queue.
const NameFilter = ({
  value,
  onChange,
  placeholder
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}) => (
  <div className="flex items-center gap-2">
    <input
      className="border rounded px-2 py-1 text-sm flex-1"
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
    {value && (
      <Button color={Color.GRAY} onClick={() => onChange('')}>
        Clear filter
      </Button>
    )}
  </div>
);

export default NameFilter;
